import { MsalAuthProvider } from 'react-aad-msal';

import { authConfig, authParams, authOptions } from 'config/auth-config';

export const msalAuthProvider = new MsalAuthProvider(
  authConfig,
  authParams,
  authOptions
);
